import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../Estilos/BotaoDuplo.css';

/**
 * @param nome (string) Nome do botão de confirmação.
 * @param nomeVolta (string) Nome do botão secundário.
 * @param externo (bool) Habilita o botão secundário para eventos externos.
 * @param top (string) Distância top.
 * @param bottom (string) Distância bottom.
 * @param disabled (bool) If true, disables the confirmation button.
 * @function clicado (void) Retorna o evento do botão de confirmação.
 * @function clicadoVolta (void) Retorna evento do botão secundário.
 * @returns
 */
export default function BotaoDuplo({
  nome,
  nomeVolta,
  externo = false,
  top = '0',
  bottom = '0',
  disabled = false,
  clicado,
  clicadoVolta
}) {
  const navigate = useNavigate();

  return (
    <div
      className="botao-duplo-container"
      style={{
        marginBottom: bottom,
        marginTop: top,
      }}
    >
      <button
        id="BotaoConfirma"
        className="botao-confirma"
        onClick={clicado}
        disabled={disabled}
      >
        {nome}
      </button>
      <button
        id="BotaoVolta"
        className="botao-volta"
        onClick={() => externo ? clicadoVolta() : navigate(-1)}
      >
        {nomeVolta}
      </button>
    </div>
  );
}
